import { render, staticRenderFns } from "./orginalPlayerCard.vue?vue&type=template&id=9ef2d200&scoped=true"
import script from "./orginalPlayerCard.vue?vue&type=script&lang=js"
export * from "./orginalPlayerCard.vue?vue&type=script&lang=js"
import style0 from "./orginalPlayerCard.vue?vue&type=style&index=0&id=9ef2d200&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ef2d200",
  null
  
)

export default component.exports